/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getManyBaseMgmtProductControllerProduct } from '../fn/product/get-many-base-mgmt-product-controller-product';
import { GetManyBaseMgmtProductControllerProduct$Params } from '../fn/product/get-many-base-mgmt-product-controller-product';
import { GetManyProductResponseDto } from '../models/get-many-product-response-dto';
import { getOneBaseMgmtProductControllerProduct } from '../fn/product/get-one-base-mgmt-product-controller-product';
import { GetOneBaseMgmtProductControllerProduct$Params } from '../fn/product/get-one-base-mgmt-product-controller-product';
import { Product } from '../models/product';

@Injectable({ providedIn: 'root' })
export class ProductApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtProductControllerProduct()` */
  static readonly GetManyBaseMgmtProductControllerProductPath = '/api/mgmt/product';

  /**
   * Retrieve multiple Products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtProductControllerProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtProductControllerProduct$Response(params?: GetManyBaseMgmtProductControllerProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyProductResponseDto>> {
    const obs = getManyBaseMgmtProductControllerProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtProductControllerProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtProductControllerProduct(params?: GetManyBaseMgmtProductControllerProduct$Params, context?: HttpContext): Observable<GetManyProductResponseDto> {
    const resp = this.getManyBaseMgmtProductControllerProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyProductResponseDto>): GetManyProductResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtProductControllerProduct()` */
  static readonly GetOneBaseMgmtProductControllerProductPath = '/api/mgmt/product/{id}';

  /**
   * Retrieve a single Product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtProductControllerProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtProductControllerProduct$Response(params: GetOneBaseMgmtProductControllerProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<Product>> {
    const obs = getOneBaseMgmtProductControllerProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtProductControllerProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtProductControllerProduct(params: GetOneBaseMgmtProductControllerProduct$Params, context?: HttpContext): Observable<Product> {
    const resp = this.getOneBaseMgmtProductControllerProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Product>): Product => r.body)
    );
  }

}
